<template>
<!--  2:55-->
  <div>
    <cancel-heading>Schedule a free 1-on-1 consultation coaching call with a Forefront System Expert</cancel-heading>
    <cancel-content>In less than 30 minutes, learn EXACTLY how to use Forefront in your specific business to drive growth.  Connect with our sales & marketing system expert and work together implementing systems that empower you to do more with less.  Let's take your efficiency to the next level, together!</cancel-content>
    <button-default @click="acceptExpertCallOffer">Sign Up for your 1-on-1 call</button-default>
  </div>
</template>

<script>
import CancelHeading from "./components/CancelHeading.vue";
import CancelContent from "./components/CancelContent.vue";

export default {
  name: "OfferExpertCall",
  components: {CancelContent, CancelHeading},
  methods: {
    acceptExpertCallOffer() {
      this.$emit('accepted')
    }
  },
}
</script>
